import { render, staticRenderFns } from "./current-number-resource.vue?vue&type=template&id=0ff6f5d1&scoped=true&"
import script from "./current-number-resource.vue?vue&type=script&lang=js&"
export * from "./current-number-resource.vue?vue&type=script&lang=js&"
import style0 from "./current-number-resource.vue?vue&type=style&index=0&id=0ff6f5d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff6f5d1",
  null
  
)

export default component.exports